import { Text } from '@libs/uikit/Components';

export const Title = ({children, ...props}) =>
    <Text style={{"marginBottom": "16px", "fontWeight": "600"}} {...props}>{children}</Text>
